import { Theme } from '@mui/material/styles';

export default function Button(theme: Theme): unknown {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        containedInherit: {
          color: theme.palette.grey[800],
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        text: {
          fontWeight: 500,
          '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            textDecoration: 'underline',
          },
        },
      },
    },
  };
}
